
// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/utils/ExploreTourHandlers.jsx

import { API_URLS, API_ENDPOINTS, getUserID } from '../api/api';
//const getUserID = () => localStorage.getItem('user_ID');

const userID = getUserID();
// if (!userID) {
//   throw new Error("User ID not found. Please log in.");
// }

const fetchContentTour = async (limit = 10, offset = 0) => {
  try {
    const url = `${API_ENDPOINTS.TOUR_VIEW}?member_id=${userID}&limit=${limit}&offset=${offset}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch ideas: ${response.statusText}`);
    }
    const data = await response.json();
    return data; // คืน object { results, limit, offset, total_count }
  } catch (error) {
    console.error('Error fetching ideas:', error);
    throw error; // โยน error ไปให้ fetchData จัดการ
  }
};

const insertContentTour = async (data) => {
  try {
    console.log('Inserting idea with payload:', JSON.stringify(data));
    const response = await fetch(API_ENDPOINTS.TOUR_INSERT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify([data]), // API expects an array
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to insert idea: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Idea inserted successfully:', result);
    return result;
  } catch (error) {
    console.error('Error inserting idea:', error);
    throw error;
  }
};

const updateContentTour = async (data) => {
  try {
    console.log('Updating idea with payload:', JSON.stringify(data));
    const response = await fetch(API_ENDPOINTS.TOUR_UPDATE, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify([data]), // API expects an array
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to update idea: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Idea updated successfully:', result);
    return result;
  } catch (error) {
    console.error('Error updating idea:', error);
    throw error;
  }
};

const deleteContentTour = async (id) => {
  try {
    console.log('Deleting idea with ID:', id);
    const response = await fetch(API_ENDPOINTS.TOUR_DELETE, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify([id]), // API expects an array
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to delete idea: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Idea deleted successfully:', result);
    return result;
  } catch (error) {
    console.error('Error deleting idea:', error);
    throw error;
  }
};


// ฟังก์ชันสำหรับอัปโหลดรูปภาพไปยัง IMAGE_UPLOAD
const uploadImageContentTour = async (files) => {
  try {
    const uploadedImages = [];

    // ตรวจสอบว่า API_ENDPOINTS.IMAGE_UPLOAD มีค่าหรือไม่
    if (!API_URLS.IMAGE_UPLOAD) {
      console.warn('Warning: IMAGE_UPLOAD endpoint is not defined in API_ENDPOINTS. Skipping image upload.');
      return uploadedImages; // คืน array ว่างเพื่อให้โค้ดทำงานต่อได้
    }

    // อัปโหลดไฟล์แต่ละไฟล์ไปยัง IMAGE_UPLOAD
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);

      console.log(`Uploading file to: ${API_URLS.IMAGE_UPLOAD}`);
      const uploadResponse = await fetch(API_URLS.IMAGE_UPLOAD, {
        method: 'POST',
        body: formData,
      });

      if (!uploadResponse.ok) {
        const errorText = await uploadResponse.text();
        throw new Error(`Failed to upload image: ${uploadResponse.status} - ${errorText}`);
      }

      const uploadResult = await uploadResponse.json();
      console.log('Image uploaded successfully:', uploadResult);

      if (!uploadResult.resizedFileURLs || !uploadResult.originalFileURLs) {
        throw new Error('Invalid response format: Missing resizedFileURLs or originalFileURLs');
      }

      uploadedImages.push({
        resizedUrl: uploadResult.resizedFileURLs[0],
        originalUrl: uploadResult.originalFileURLs[0],
      });
    }

    return uploadedImages; // คืน array ของ URL รูปภาพที่อัปโหลด
  } catch (error) {
    console.error('Error in uploadImageContentTour:', error);
    throw error;
  }
};

// ฟังก์ชันสำหรับบันทึกข้อมูลรูปภาพไปยัง TOUR_IMAGE_INSERT
const insertImageContentTour = async (imageDataList) => {
  try {
    // ตรวจสอบว่า imageDataList มีข้อมูลหรือไม่
    if (imageDataList.length === 0) {
      console.warn('Warning: No image data to insert into TOUR_IMAGE_INSERT. Skipping.');
      return imageDataList; // คืน array ว่าง
    }

    // ตรวจสอบว่า API_ENDPOINTS.TOUR_IMAGE_INSERT มีค่าหรือไม่
    if (!API_ENDPOINTS.TOUR_IMAGE_INSERT) {
      console.warn('Warning: TOUR_IMAGE_INSERT endpoint is not defined in API_ENDPOINTS. Skipping image insertion.');
      return imageDataList; // คืน imageDataList เพื่อให้โค้ดทำงานต่อได้
    }

    // ส่งข้อมูลไปยัง TOUR_IMAGE_INSERT
    console.log('Inserting image data to TOUR_IMAGE_INSERT:', JSON.stringify(imageDataList));
    const insertImageResponse = await fetch(API_ENDPOINTS.TOUR_IMAGE_INSERT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(imageDataList),
    });

    if (!insertImageResponse.ok) {
      const errorText = await insertImageResponse.text();
      throw new Error(`Failed to insert image data: ${insertImageResponse.status} - ${errorText}`);
    }

    const insertImageResult = await insertImageResponse.json();
    console.log('Image data inserted successfully:', insertImageResult);

    return insertImageResult; // ส่งผลลัพธ์การบันทึกกลับไป
  } catch (error) {
    console.error('Error in insertImageContentTour:', error);
    throw error;
  }
};

// ฟังก์ชันสำหรับอัปเดตข้อมูลรูปภาพที่ TOUR_IMAGE_UPDATE
const updateImageContentTour = async (imageDataList) => {
  try {
    // ตรวจสอบว่า imageDataList มีข้อมูลหรือไม่
    if (imageDataList.length === 0) {
      console.warn('Warning: No image data to update in TOUR_IMAGE_UPDATE. Skipping.');
      return imageDataList; // คืน array ว่าง
    }

    // ตรวจสอบว่า API_ENDPOINTS.TOUR_IMAGE_UPDATE มีค่าหรือไม่
    if (!API_ENDPOINTS.TOUR_IMAGE_UPDATE) {
      console.warn('Warning: CONTENT_IMAGE_UPDATE endpoint is not defined in API_ENDPOINTS. Skipping image update.');
      return imageDataList; // คืน imageDataList เพื่อให้โค้ดทำงานต่อได้
    }

    // ส่งข้อมูลไปยัง TOUR_IMAGE_UPDATE
    console.log('Updating image data to CONTENT_IMAGE_UPDATE:', JSON.stringify(imageDataList));
    const updateImageResponse = await fetch(API_ENDPOINTS.TOUR_IMAGE_UPDATE, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(imageDataList),
    });

    if (!updateImageResponse.ok) {
      const errorText = await updateImageResponse.text();
      throw new Error(`Failed to update image data: ${updateImageResponse.status} - ${errorText}`);
    }

    const updateImageResult = await updateImageResponse.json();
    console.log('Image data updated successfully:', updateImageResult);

    return updateImageResult; // ส่งผลลัพธ์การอัปเดตกลับไป
  } catch (error) {
    console.error('Error in updateImageContentTour:', error);
    throw error;
  }
};

// ฟังก์ชันสำหรับดึงข้อมูลรูปภาพจาก TOUR_IMAGE_VIEW
const fetchImageContentTour = async (homeId) => {
  try {
    if (!homeId) {
      throw new Error('Home_ID is required to fetch content images');
    }

    // ตรวจสอบว่า API_ENDPOINTS.TOUR_IMAGE_VIEW มีค่าหรือไม่
    if (!API_ENDPOINTS.TOUR_IMAGE_VIEW) {
      throw new Error('TOUR_IMAGE_VIEW endpoint is not defined in API_ENDPOINTS');
    }

    const url = `${API_ENDPOINTS.TOUR_IMAGE_VIEW}?Home_ID=${homeId}`;
    console.log(`Fetching content images from: ${url}`);
    const response = await fetch(url);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to fetch content images: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log('Content images fetched successfully:', data);

    // ตรวจสอบว่า data มีฟิลด์ results หรือไม่
    if (!data.results || !Array.isArray(data.results)) {
      throw new Error('Invalid response format: Expected "results" array in API response');
    }

    return data.results; // คืนเฉพาะ array ของ results
  } catch (error) {
    console.error('Error fetching content images:', error);
    throw error;
  }
};

// ฟังก์ชันสำหรับลบรูปภาพจาก TOUR_IMAGE_DELETE (ปรับปรุง)
const deleteImageContentTour = async (imgHomeIDs) => {
  try {
    if (!Array.isArray(imgHomeIDs) || imgHomeIDs.length === 0) {
      throw new Error('imgHomeIDs must be a non-empty array');
    }

    if (!API_ENDPOINTS.TOUR_IMAGE_DELETE) {
      throw new Error('TOUR_IMAGE_DELETE endpoint is not defined in API_ENDPOINTS');
    }

    // ตรวจสอบว่า imgHomeIDs ทุกตัวเป็นตัวเลข
    const isValidIDs = imgHomeIDs.every(id => typeof id === 'number' && !isNaN(id));
    if (!isValidIDs) {
      throw new Error('All imgHomeIDs must be valid numbers');
    }

    // ส่ง ImgHome_ID ใน JSON body ในรูปแบบ [1511, 1512]
    const payload = imgHomeIDs;

    console.log('Deleting images with payload:', JSON.stringify(payload));
    const response = await fetch(API_ENDPOINTS.TOUR_IMAGE_DELETE, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to delete images: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    console.log('Images deleted successfully:', result);
    return result;
  } catch (error) {
    console.error('Error deleting images:', error);
    throw error;
  }
};


export { fetchContentTour, insertContentTour, updateContentTour, deleteContentTour, uploadImageContentTour, insertImageContentTour, updateImageContentTour, fetchImageContentTour, deleteImageContentTour };